/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Article_Groups_TitleInputs */



/**
* | output |
* | --- |
* | "Groups" |
*
* @param {Help_Article_Groups_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const help_article_groups_title = /** @type {((inputs?: Help_Article_Groups_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Article_Groups_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gruppen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Groupes")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("小组")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("社團")
	if (locale === "ko") return /** @type {LocalizedString} */ ("그룹")
	return /** @type {LocalizedString} */ ("Groups")
});